import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

type CacheEntry<T> = { expiresAt: number; obs$: Observable<T> };

export const HTTP_CACHE_TTL_MS = {
  CRITICAL: 30_000,
  IMPORTANT: 60_000,
  REGULAR: 90_000,
  UNIMPORTANT: 10 * 60_000,
} as const;


@Injectable({ providedIn: 'root' })
export class HttpCacheService {
  private readonly store = new Map<string, CacheEntry<unknown>>();

  getOrSet<T>(key: string, ttlMs: number, factory: () => Observable<T>): Observable<T> {
    const now = Date.now();
    const hit = this.store.get(key) as CacheEntry<T> | undefined;

    if (hit && now < hit.expiresAt) return hit.obs$;

    const obs$ = factory().pipe(shareReplay({ bufferSize: 1, refCount: false }));
    this.store.set(key, { expiresAt: now + ttlMs, obs$ });
    return obs$;
  }

  invalidate(keyPrefix?: string): void {
    if (!keyPrefix) return void this.store.clear();
    for (const k of this.store.keys()) if (k.startsWith(keyPrefix)) this.store.delete(k);
  }
}
